import { HeaderZodValidators } from '@agilelab/plugin-wb-platform-common';
import { z } from 'zod';

export const HeaderInputSchema = z.object({
  key: HeaderZodValidators.name,
  value: HeaderZodValidators.value,
  isSensitive: z.boolean(),
});
